import { Component, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SearchPageService } from '../../../search-page.service';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../../../services/notification.service';

@Component({
    selector: 'se-same-study-renderer',
    templateUrl: './same-study-renderer.component.html',
    styleUrls: ['./same-study-renderer.component.scss'],
    standalone: false
})
export class SameStudyRendererComponent implements ICellRendererAngularComp {
    @ViewChild('tooltip') tooltipEl: MatTooltip;
    clicked: number = 0;
    examinations: string[] = [];
    loading: boolean = false;
    rowData: any;
    private SameStudyIconClick: Function = () => null;

    constructor(
        private searchPageService: SearchPageService,
        private notificationService: NotificationService,
        private translate: TranslateService) {
    }

    agInit(params: ICellRendererParams<any, any, any>): void {
        this.updateParams(params);
    }

    refresh(params: ICellRendererParams<any, any, any>): boolean {
        this.updateParams(params);
        return true;
    }

    onIconClick(event: MouseEvent) {
        event.stopPropagation();
        this.SameStudyIconClick(event, this.rowData);
    }

    private updateParams(params: ICellRendererParams<any, any, any>) {
        this.rowData = params.data;
        this.SameStudyIconClick = params.context.SameStudyIconClick || (() => null);
    }


    private reverseDate(isoDate: string): string {
        return isoDate.match(/([^T]+)/)?.[0]?.split('-').reverse().join('/') ?? '';
    }
}
